//import React from 'react';
import {React, useEffect, useState, useRef, useLayoutEffect} from 'react';
import './App.css';
import Navbar from './components/navbar';
import { BrowserRouter as Router, Routes, Route }
	from 'react-router-dom';
//import Home from './pages';
import Home from './pages/index2';
import About from './pages/about';
import Admin from './pages/admin3';
import Contact from './pages/contact';
import Tree_Trimming from './pages/tree_trimming';
import Tree_Removal from './pages/tree_removal';
import Stump_Removal from './pages/stump_removal';
import Debris_Hauling from './pages/debris_hauling';
import Tree_Service_Sarasota from './pages/tree_service_sarasota';
import Tree_Service_Sarasota2 from './pages/tree_service_sarasota2';
import Tree_Service_Bee_Ridge from './pages/tree_service_bee_ridge';
import Tree_Service_Casey_Key from './pages/tree_service_casey_key';
import Tree_Service_Fruitville from './pages/tree_service_fruitville';
import Tree_Service_Gulf_Gate_Estates from './pages/tree_service_gulf_gate_estates';
import Tree_Service_Kensington_Park from './pages/tree_service_kensington_park';
import Tree_Service_Laurel from './pages/tree_service_laurel';
import Tree_Service_Lido_Key from './pages/tree_service_lido_key';
import Tree_Service_Nokomis from './pages/tree_service_nokomis';
import Tree_Service_Ridge_Wood_Heights from './pages/tree_service_ridge_wood_heights';
import Tree_Service_Sarasota_Springs from './pages/tree_service_sarasota_springs';
import Tree_Service_South_Venice from './pages/tree_service_south_venice';
import Tree_Service_The_Meadows from './pages/tree_service_the_meadows';
import Tree_Service_Vamo from './pages/tree_service_vamo';
import Tree_Service_StPete from './pages/tree_service_stpete';
import Tree_Service_Bay_Pines from './pages/tree_service_bay_pines';
import Tree_Service_Belleair_Beach from './pages/tree_service_belleair_beach';
import Tree_Service_Belleair_Shore from './pages/tree_service_belleair_shore';
import Tree_Service_Gulfport from './pages/tree_service_gulfport';
import Tree_Service_Indian_Rocks_Beach from './pages/tree_service_indian_rocks_beach';
import Tree_Service_Indian_Shores from './pages/tree_service_indian_shores';
import Tree_Service_Lealman from './pages/tree_service_lealman';
import Tree_Service_Madeira_Beach from './pages/tree_service_madeira_beach';
import Tree_Service_North_Redington_Beach from './pages/tree_service_north_redington_beach';
import Tree_Service_Pass_A_Grille from './pages/tree_service_pass_a_grille';
import Tree_Service_Redington_Beach from './pages/tree_service_redington_beach';
import Tree_Service_Redington_Shores from './pages/tree_service_redington_shores';
import Tree_Service_South_Pasadena from './pages/tree_service_south_pasadena';
import Tree_Service_St_Pete_Beach from './pages/tree_service_st_pete_beach';
import Tree_Service_Tierra_Verde from './pages/tree_service_tierra_verde';
import Tree_Service_Treasure_Island from './pages/tree_service_treasure_island';
import Tree_Service_Apollo_Beach from './pages/tree_service_apollo_beach';
import Tree_Service_Balm from './pages/tree_service_balm';
import Tree_Service_Carrollwood from './pages/tree_service_carrollwood';
import Tree_Service_Citrus_Park from './pages/tree_service_citrus_park';
import Tree_Service_Downtown_Tampa from './pages/tree_service_downtown_tampa';
import Tree_Service_Bloomingdale from './pages/tree_service_bloomingdale';
import Tree_Service_Brandon from './pages/tree_service_brandon';
import Tree_Service_East_Tampa from './pages/tree_service_east_tampa';
import Tree_Service_Egypt_Lake_Leto from './pages/tree_service_egypt_lake_leto';
import Tree_Service_Fish_Hawk from './pages/tree_service_fish_hawk';
import Tree_Service_Gibsonton from './pages/tree_service_gibsonton';
import Tree_Service_Hyde_Park from './pages/tree_service_hyde_park';
import Tree_Service_Keystone from './pages/tree_service_keystone';
import Tree_Service_Lithia from './pages/tree_service_lithia';
import Tree_Service_Lutz from './pages/tree_service_lutz';
import Tree_Service_Mango from './pages/tree_service_mango';
import Tree_Service_New_Tampa from './pages/tree_service_new_tampa';
import Tree_Service_North_Tampa from './pages/tree_service_north_tampa';
import Tree_Service_Northdale from './pages/tree_service_northdale';
import Tree_Service_Palm_River_Clair_Mel from './pages/tree_service_palm_river_clair_mel';
import Tree_Service_Palma_Ceia from './pages/tree_service_palma_ceia';
import Tree_Service_Progress_Village from './pages/tree_service_progress_village';
import Tree_Service_Seffner from './pages/tree_service_seffner';
import Tree_Service_Seminole_Heights from './pages/tree_service_seminole_heights';
import Tree_Service_South_Hillsborough from './pages/tree_service_south_hillsborough';
import Tree_Service_South_Tampa from './pages/tree_service_south_tampa';
import Tree_Service_Sun_City_Center from './pages/tree_service_sun_city_center';
import Tree_Service_Temple_Terrace from './pages/tree_service_temple_terrace';
import Tree_Service_Town_N_Country from './pages/tree_service_town_n_country';
import Tree_Service_University from './pages/tree_service_university';
import Tree_Service_Valrico from './pages/tree_service_valrico';
import Tree_Service_West_Tampa from './pages/tree_service_west_tampa';
import Tree_Service_Westchase from './pages/tree_service_westchase';
import Tree_Service_Wimauma from './pages/tree_service_wimauma';
import Tree_Service_Ybor_City from './pages/tree_service_ybor_city';
import Tree_Service_Ballast_Point from './pages/tree_service_ballast_point';
import Tree_Service_Davis_Islands from './pages/tree_service_davis_islands';

import Tree_Service_Tampa from './pages/tree_service_tampa';
import Tree_Service_Tampa2 from './pages/tree_service_tampa2';
import Tree_Service_Bradenton from './pages/tree_service_bradenton';
import Tree_Service_Anna_Maria from './pages/tree_service_anna_maria';
import Tree_Service_Bayshore_Gardens from './pages/tree_service_bayshore_gardens';
import Tree_Service_Bradenton_Beach from './pages/tree_service_bradenton_beach';
import Tree_Service_Cortez from './pages/tree_service_cortez';
import Tree_Service_Ellenton from './pages/tree_service_ellenton';
import Tree_Service_Holmes_Beach from './pages/tree_service_holmes_beach';
import Tree_Service_Memphis from './pages/tree_service_memphis';
import Tree_Service_Myakka_City from './pages/tree_service_myakka_city';
import Tree_Service_Oneco from './pages/tree_service_oneco';
import Tree_Service_Rubonia from './pages/tree_service_rubonia';
import Tree_Service_Samoset from './pages/tree_service_samoset';
import Tree_Service_South_Bradenton from './pages/tree_service_south_bradenton';
import Tree_Service_Tallevast from './pages/tree_service_tallevast';
import Tree_Service_Whitfield_Estates from './pages/tree_service_whitfield_estates';
import Tree_Service_Whitfield from './pages/tree_service_whitfield';
import Tree_Service_Duette from './pages/tree_service_duette';
import Tree_Service_Siesta_Key from './pages/tree_service_siesta_key';
import Tree_Service_Longboat_Key from './pages/tree_service_longboat_key';
import Tree_Service_Lakewood_Ranch from './pages/tree_service_lakewood_ranch';
import Tree_Service_Venice from './pages/tree_service_venice';
import Tree_Service_Palmetto from './pages/tree_service_palmetto';
import Tree_Service_North_Port from './pages/tree_service_north_port';
import Tree_Service_Osprey from './pages/tree_service_osprey';
import Tree_Service_Palmer_Ranch from './pages/tree_service_palmer_ranch';
import Tree_Service_Englewood from './pages/tree_service_englewood';
import Tree_Service_Punta_Gorda from './pages/tree_service_punta_gorda';
import Tree_Service_Ruskin from './pages/tree_service_ruskin';
import Tree_Service_Riverview from './pages/tree_service_riverview';
import Tree_Service_Pinellas_Park from './pages/tree_service_pinellas_park';
import Tree_Service_Parrish from './pages/tree_service_parrish';
import Blog from './pages/blog';
import TreeTrimmingSarasota from './pages/blog/TreeTrimmingSarasota';
import StumpGrindingGuide from './pages/blog/StumpGrindingGuide';
import HurricaneSeasonTreeCare from './pages/blog/HurricaneSeasonTreeCare';
import Reviews from './pages/reviews'
import { PiPhoneCallBold } from "react-icons/pi";
 import { FiCalendar } from "react-icons/fi";
 import UserModal from './pages/UserModal';

function App() {

	const [isModalOpen, setIsModalOpen] = useState(false);
	const openModal = () => setIsModalOpen(true);
	const closeModal = () => setIsModalOpen(false);

	useEffect(() => {
    let startY = 0;
  
    const onWheel = (e) => {
      const atTop    = window.scrollY <= 0;
      const atBottom = window.scrollY + window.innerHeight >= document.body.scrollHeight;
      if ((atTop && e.deltaY < 0) || (atBottom && e.deltaY > 0)) {
        e.preventDefault();
      }
    };
  
    const onTouchStart = (e) => { startY = e.touches[0].clientY; };
  
    const onTouchMove = (e) => {
      const delta   = startY - e.touches[0].clientY;
      const atTop    = window.scrollY <= 0;
      const atBottom = window.scrollY + window.innerHeight >= document.body.scrollHeight;
      if ((atTop && delta < 0) || (atBottom && delta > 0)) {
        e.preventDefault();
      }
    };
  
    document.addEventListener('wheel',      onWheel,      { passive: false });
    document.addEventListener('touchstart', onTouchStart, { passive: true  });
    document.addEventListener('touchmove',  onTouchMove,  { passive: false });
  
    return () => {
      document.removeEventListener('wheel',      onWheel);
      document.removeEventListener('touchstart', onTouchStart);
      document.removeEventListener('touchmove',  onTouchMove);
    };
  }, []);


	return (
		<Router>
			<Navbar />
			<Routes>
				<Route exact path='/' element={<Home />} />
				<Route path='/about' element={<About />} />
				<Route path='/contact' element={<Contact />} />
        		<Route path='/tree_trimming' element={<Tree_Trimming />} />
        		<Route path='/tree_removal' element={<Tree_Removal />} />
        		<Route path='/stump_removal' element={<Stump_Removal />} />
        		<Route path='/debris_hauling' element={<Debris_Hauling />} />
				<Route path='/tree_service_sarasota' element={<Tree_Service_Sarasota />} />
				<Route path='/tree_service_sarasota2' element={<Tree_Service_Sarasota2 />} />
				<Route path='/tree_service_bee_ridge' element={<Tree_Service_Bee_Ridge />} />
				<Route path='/tree_service_casey_key' element={<Tree_Service_Casey_Key />} />
				<Route path='/tree_service_fruitville' element={<Tree_Service_Fruitville />} />
				<Route path='/tree_service_gulf_gate_estates' element={<Tree_Service_Gulf_Gate_Estates />} />
				<Route path='/tree_service_kensington_park' element={<Tree_Service_Kensington_Park />} />
				<Route path='/tree_service_laurel' element={<Tree_Service_Laurel />} />
				<Route path='/tree_service_lido_key' element={<Tree_Service_Lido_Key />} />
				<Route path='/tree_service_nokomis' element={<Tree_Service_Nokomis />} />
				<Route path='/tree_service_ridge_wood_heights' element={<Tree_Service_Ridge_Wood_Heights />} />
				<Route path='/tree_service_sarasota_springs' element={<Tree_Service_Sarasota_Springs />} />
				<Route path='/tree_service_south_venice' element={<Tree_Service_South_Venice />} />
				<Route path='/tree_service_the_meadows' element={<Tree_Service_The_Meadows />} />
				<Route path='/tree_service_vamo' element={<Tree_Service_Vamo />} />
				<Route path='/tree_service_stpete' element={<Tree_Service_StPete />} />
				<Route path='/tree_service_bay_pines' element={<Tree_Service_Bay_Pines />} />
				<Route path='/tree_service_belleair_beach' element={<Tree_Service_Belleair_Beach />} />
				<Route path='/tree_service_belleair_shore' element={<Tree_Service_Belleair_Shore />} />
				<Route path='/tree_service_indian_rocks_beach' element={<Tree_Service_Indian_Rocks_Beach />} />
				<Route path='/tree_service_indian_shores' element={<Tree_Service_Indian_Shores />} />
				<Route path='/tree_service_lealman' element={<Tree_Service_Lealman />} />
				<Route path='/tree_service_madeira_beach' element={<Tree_Service_Madeira_Beach />} />
				<Route path='/tree_service_north_redington_beach' element={<Tree_Service_North_Redington_Beach />} />
				<Route path='/tree_service_pass_a_grille' element={<Tree_Service_Pass_A_Grille />} />
				<Route path='/tree_service_redington_beach' element={<Tree_Service_Redington_Beach />} />
				<Route path='/tree_service_redington_shores' element={<Tree_Service_Redington_Shores />} />
				<Route path='/tree_service_south_pasadena' element={<Tree_Service_South_Pasadena />} />
				<Route path='/tree_service_st_pete_beach' element={<Tree_Service_St_Pete_Beach />} />
				<Route path='/tree_service_tierra_verde' element={<Tree_Service_Tierra_Verde />} />
				<Route path='/tree_service_treasure_island' element={<Tree_Service_Treasure_Island />} />
				<Route path='/tree_service_apollo_beach' element={<Tree_Service_Apollo_Beach />} />
				<Route path='/tree_service_balm' element={<Tree_Service_Balm />} />
				<Route path='/tree_service_brandon' element={<Tree_Service_Brandon />} />
				<Route path='/tree_service_bloomingdale' element={<Tree_Service_Bloomingdale />} />
				<Route path='/tree_service_carrollwood' element={<Tree_Service_Carrollwood />} />
				<Route path='/tree_service_citrus_park' element={<Tree_Service_Citrus_Park />} />
				<Route path='/tree_service_downtown_tampa' element={<Tree_Service_Downtown_Tampa />} />
				<Route path='/tree_service_east_tampa' element={<Tree_Service_East_Tampa />} />
				<Route path='/tree_service_egypt_lake_leto' element={<Tree_Service_Egypt_Lake_Leto />} />
				<Route path='/tree_service_fish_hawk' element={<Tree_Service_Fish_Hawk />} />
				<Route path='/tree_service_gibsonton' element={<Tree_Service_Gibsonton />} />
				<Route path='/tree_service_hyde_park' element={<Tree_Service_Hyde_Park />} />
				<Route path='/tree_service_keystone' element={<Tree_Service_Keystone />} />
				<Route path='/tree_service_lithia' element={<Tree_Service_Lithia />} />
				<Route path='/tree_service_lutz' element={<Tree_Service_Lutz />} />
				<Route path='/tree_service_mango' element={<Tree_Service_Mango />} />
				<Route path='/tree_service_new_tampa' element={<Tree_Service_New_Tampa />} />
				<Route path='/tree_service_north_tampa' element={<Tree_Service_North_Tampa />} />
				<Route path='/tree_service_northdale' element={<Tree_Service_Northdale />} />
				<Route path='/tree_service_palm_river_clair_mel' element={<Tree_Service_Palm_River_Clair_Mel />} />
				<Route path='/tree_service_palma_ceia' element={<Tree_Service_Palma_Ceia />} />
				<Route path='/tree_service_progress_village' element={<Tree_Service_Progress_Village />} />
				<Route path='/tree_service_seffner' element={<Tree_Service_Seffner />} />
				<Route path='/tree_service_seminole_heights' element={<Tree_Service_Seminole_Heights />} />
				<Route path='/tree_service_south_hillsborough' element={<Tree_Service_South_Hillsborough />} />
				<Route path='/tree_service_south_tampa' element={<Tree_Service_South_Tampa />} />
				<Route path='/tree_service_sun_city_center' element={<Tree_Service_Sun_City_Center />} />
				<Route path='/tree_service_temple_terrace' element={<Tree_Service_Temple_Terrace />} />
				<Route path='/tree_service_town_n_country' element={<Tree_Service_Town_N_Country />} />
				<Route path='/tree_service_university' element={<Tree_Service_University />} />
				<Route path='/tree_service_west_tampa' element={<Tree_Service_West_Tampa />} />
				<Route path='/tree_service_westchase' element={<Tree_Service_Westchase />} />
				<Route path='/tree_service_valrico' element={<Tree_Service_Valrico />} />
				<Route path='/tree_service_wimauma' element={<Tree_Service_Wimauma />} />
				<Route path='/tree_service_ybor_city' element={<Tree_Service_Ybor_City />} />
				<Route path='/tree_service_ballast_point' element={<Tree_Service_Ballast_Point />} />
				<Route path='/tree_service_davis_islands' element={<Tree_Service_Davis_Islands />} />
				<Route path='/tree_service_tampa2' element={<Tree_Service_Tampa2 />} />
				<Route path='/tree_service_gulfport' element={<Tree_Service_Gulfport />} />
				<Route path='/tree_service_tampa' element={<Tree_Service_Tampa />} />
				<Route path='/tree_service_bradenton' element={<Tree_Service_Bradenton />} />
				<Route path='/tree_service_anna_maria' element={<Tree_Service_Anna_Maria />} />
				<Route path='/tree_service_bayshore_gardens' element={<Tree_Service_Bayshore_Gardens />} />
				<Route path='/tree_service_bradenton_beach' element={<Tree_Service_Bradenton_Beach />} />
				<Route path='/tree_service_cortez' element={<Tree_Service_Cortez />} />
				<Route path='/tree_service_duette' element={<Tree_Service_Duette />} />
				<Route path='/tree_service_ellenton' element={<Tree_Service_Ellenton />} />
				<Route path='/tree_service_holmes_beach' element={<Tree_Service_Holmes_Beach />} />
				<Route path='/tree_service_memphis' element={<Tree_Service_Memphis />} />
				<Route path='/tree_service_myakka_city' element={<Tree_Service_Myakka_City />} />
				<Route path='/tree_service_oneco' element={<Tree_Service_Oneco />} />
				<Route path='/tree_service_rubonia' element={<Tree_Service_Rubonia />} />
				<Route path='/tree_service_samoset' element={<Tree_Service_Samoset />} />
				<Route path='/tree_service_south_bradenton' element={<Tree_Service_South_Bradenton />} />
				<Route path='/tree_service_tallevast' element={<Tree_Service_Tallevast />} />
				<Route path='/tree_service_whitfield_estates' element={<Tree_Service_Whitfield_Estates />} />
				<Route path='/tree_service_whitfield' element={<Tree_Service_Whitfield />} />
				<Route path='/tree_service_siesta_key' element={<Tree_Service_Siesta_Key />} />
				<Route path='/tree_service_longboat_key' element={<Tree_Service_Longboat_Key />} />
				<Route path='/tree_service_lakewood_ranch' element={<Tree_Service_Lakewood_Ranch />} />
				<Route path='/tree_service_venice' element={<Tree_Service_Venice />} />
				<Route path='/tree_service_palmetto' element={<Tree_Service_Palmetto />} />
				<Route path='/tree_service_north_port' element={<Tree_Service_North_Port />} />
				<Route path='/tree_service_osprey' element={<Tree_Service_Osprey />} />
				<Route path='/tree_service_palmer_ranch' element={<Tree_Service_Palmer_Ranch />} />
				<Route path='/tree_service_englewood' element={<Tree_Service_Englewood />} />
				<Route path='/tree_service_punta_gorda' element={<Tree_Service_Punta_Gorda />} />
				<Route path='/tree_service_ruskin' element={<Tree_Service_Ruskin />} />
				<Route path='/tree_service_riverview' element={<Tree_Service_Riverview />} />
				<Route path='/tree_service_pinellas_park' element={<Tree_Service_Pinellas_Park />} />
				<Route path='/tree_service_parrish' element={<Tree_Service_Parrish />} />
				<Route path='/blog' element={<Blog />} />
				<Route path="/blog/tree-trimming-sarasota" element={<TreeTrimmingSarasota />}/>
				<Route path="/blog/stump-grinding-guide" element={<StumpGrindingGuide />} />
				<Route path="/blog/hurricane-season-tree-care" element={<HurricaneSeasonTreeCare />} />
        		<Route path='/reviews' element={<Reviews />} />
        		<Route path='/admin' element={<Admin />} />
			</Routes>
      <div className='contact_app' onClick={() => window.location.href = 'tel:941-879-8853'}>
        <div className='circle_icon_contact_app'><PiPhoneCallBold /></div>
      </div>

	  <div className='apt_app' onClick={(e) => {
    						e.preventDefault(); // Prevent the default link action
    						openModal();
  						}}>
        <div className='circle_icon_apt_app'><FiCalendar /></div>
      </div>
	    {isModalOpen && <UserModal onClose={closeModal} />}
		<UserModal isOpen={isModalOpen} onClose={closeModal} />
	  
		</Router>
	);
}

export default App;


